import { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSnackbar } from 'notistack';
import server from '../../../global/server';

const LIMITE_MOTIVO = 200;

const formatar = data =>
    data ? new Date(data).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';

/**
 * Cancelamento de um horario pelo anfitriao.
 *
 * Diferente de remover um horario vazio, aqui existe gente que pagou. O aviso e
 * o estorno sao feitos pelo servidor; a tela deixa claro o custo da decisao
 * antes de o anfitriao confirmar.
 */
export default ({ open, schedule, gratuito, onClose, onCanceled }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [motivo, setMotivo] = useState('');
    const [cancelando, setCancelando] = useState(false);

    useEffect(() => {
        if (open) setMotivo('');
    }, [open, schedule?.id]);

    const convivas = Array.isArray(schedule?.Order)
        ? schedule.Order.filter(o => ['CONCLUDED', 'PENDING'].includes(o.status)).length
        : 0;

    const cancelar = async () => {
        try {
            setCancelando(true);
            const { data } = await server.post(
                `/profile/meeting/schedule/${schedule.id}/cancel`,
                { reason: motivo.trim() || undefined },
            );
            enqueueSnackbar(data?.message || 'Horário cancelado', { variant: 'success' });
            onCanceled?.();
            onClose?.();
        } catch (error) {
            enqueueSnackbar(error.response?.data?.message || 'Erro ao cancelar o horário', {
                variant: 'error',
            });
        } finally {
            setCancelando(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}>
            <DialogTitle sx={{ fontWeight: 600 }}>Cancelar encontro</DialogTitle>

            <DialogContent>
                <Stack spacing={2} sx={{ pt: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        Horário: <strong>{formatar(schedule?.datetime)}</strong>
                    </Typography>

                    {convivas > 0 ? (
                        <Alert severity="error" sx={{ borderRadius: '12px' }}>
                            {convivas === 1 ? '1 conviva perderá' : `${convivas} convivas perderão`} a vaga.
                            {gratuito
                                ? ' Eles serão avisados pelo WhatsApp.'
                                : ` ${convivas === 1 ? 'Ele' : 'Eles'} serão avisados e receberão o reembolso integral.`}
                            {' '}Esta ação é irreversível.
                        </Alert>
                    ) : (
                        <Alert severity="warning" sx={{ borderRadius: '12px' }}>
                            Ninguém adquiriu este horário. Ele deixará de aparecer na plataforma.
                        </Alert>
                    )}

                    <TextField
                        label="Motivo (opcional)"
                        placeholder="Ex.: imprevisto de agenda"
                        size="small"
                        fullWidth
                        multiline
                        minRows={2}
                        value={motivo}
                        onChange={e => setMotivo(e.target.value.slice(0, LIMITE_MOTIVO))}
                        helperText={
                            convivas > 0
                                ? `Se preenchido, será enviado aos convivas. ${motivo.length}/${LIMITE_MOTIVO}`
                                : `${motivo.length}/${LIMITE_MOTIVO}`
                        }
                    />
                </Stack>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} sx={{ textTransform: 'none', color: '#666' }}>
                    Voltar
                </Button>
                <LoadingButton
                    onClick={cancelar}
                    loading={cancelando}
                    variant="contained"
                    color="error"
                    sx={{ textTransform: 'none' }}
                >
                    Cancelar encontro
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};
